import styled from 'styled-components';

import { responseType, rsColor } from '../../responseScale';

// 6473:12804 / 12837: "1 · Choose actionable metrics", "2 · Handoff checks".
export const StepHeading = styled.h5`
  margin: 0;
  color: ${rsColor.text};
  ${responseType('handoffHeading')}
`;
